import React from 'react'
import { TextField, FormControl,Grid, InputLabel, Select,IconButton,Slider, MenuItem,Typography,Box,Accordion,AccordionSummary,AccordionDetails } from '@mui/material';
import useEmailEditorStore from '../../utilities/emailEditorStore';
import BlockProps from './common/BlockProps';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormatAlignCenter,FormatAlignLeft,FormatAlignRight,RoundedCorner } from '@mui/icons-material';
function ImageBlockProperties({blockId}) {

const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };

  return (
     <>
            <TextField
              fullWidth
              label="Image URL"
              value={properties.src || ''}
              onChange={(e) => handlePropertyChange('src', e.target.value)}
              sx={{ mb: 2 }}
            />
            
            <TextField
              fullWidth
              label="Alt Text"
              value={properties.alt || ''}
              onChange={(e) => handlePropertyChange('alt', e.target.value)}
              sx={{ mb: 2 }}
            />
            <Box>
              {/** Image Properties DropDown */}
              <Accordion sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                        Image Settings
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                       <Box>
                          <Grid container spacing={2} >
                              <Grid size={6}>
                                  <TextField
                                                fullWidth
                                                label="Width"
                                                value={properties.width || '100%'}
                                                onChange={(e) => handlePropertyChange('width', e.target.value)}
                                                sx={{ mb: 2 }}
                                              />
                              </Grid>
                              <Grid size={6}>
                                  <TextField
                                              fullWidth
                                              label="Height"
                                              value={properties.height || 'auto'}
                                              onChange={(e) => handlePropertyChange('height', e.target.value)}
                                              sx={{ mb: 2 }}
                                            />
                              </Grid>
                          </Grid>
                       </Box>
                       <Box>
                         <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                            Alignment
                          </Typography>
                          <Box>
                            <IconButton 
                              onClick={() => handlePropertyChange('textAlign', 'left')}
                              color={properties.textAlign === 'left' ? 'primary' : 'default'}
                            >
                              <FormatAlignLeft />
                            </IconButton>
                            <IconButton 
                              onClick={() => handlePropertyChange('textAlign', 'center')}
                              color={properties.textAlign === 'center' ? 'primary' : 'default'}
                            >
                              <FormatAlignCenter />
                            </IconButton>
                            <IconButton 
                              onClick={() => handlePropertyChange('textAlign', 'right')}
                              color={properties.textAlign === 'right' ? 'primary' : 'default'}
                            >
                              <FormatAlignRight />
                            </IconButton>
                          
                          </Box>
                       </Box>
                       <Box>
                         <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                            Border Radius
                          </Typography>
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                                <RoundedCorner />
                            </Grid>
                            <Grid size="grow">
                            <Slider
                                value={properties.imgborderRadius}
                                onChange={(e) => handlePropertyChange('imgborderRadius', e.target.value)}
                                aria-labelledby="input-slider-borderradius"
                                step={1}
                                marks
                                max= {600}
                            />
                            </Grid>
                            <Grid>
                                <Typography variant="body2" gutterBottom>
                                   {properties.imgborderRadius} px
                                </Typography>
                            </Grid>
                            
                    </Grid>
                        </Box>
                    </AccordionDetails>
              </Accordion>
              <BlockProps properties={properties} onPropertyChange={handlePropertyChange} />
            </Box>
           
            
          

            
          
          </>
  )
}

export default ImageBlockProperties